import { Link } from '@twistopayments/design-system/components/atoms/link'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type {
  ContactContactItemComponent,
  SectionsContactInfoComponent,
} from '@twisto/api-cms'

import { BaseLink, StrapiMedia } from 'homepage/components/atoms'
import { useHighlightedText } from 'homepage/libs/hooks'

import { Paragraph } from '../../article-components'
import { Icon } from '../../atoms'
import type { RichTextBlock } from '../../rich-text/rich-text.d'

import * as styles from './contact-info.styles'

const ContactItem = ({
  iconName,
  link,
  name,
  title,
  subtitle,
  image,
  highlighted,
  description,
}: ContactContactItemComponent) => {
  const { before, after, highlight } = useHighlightedText(title, highlighted)

  return (
    <div css={styles.contactItem}>
      {iconName && (
        <div css={styles.icon}>
          <Icon name={iconName} size="24" />
        </div>
      )}
      <div>
        <Link css={styles.title} to={link?.link}>
          {before}
          <span css={styles.highlighted}>{highlight}</span>
          {after}
        </Link>

        <Typography css={styles.subtitle}>{subtitle}</Typography>
        <Typography css={styles.description}>{description}</Typography>
        <Typography css={styles.name}>{name}</Typography>

        {link?.text && (
          <div css={styles.link}>
            <BaseLink text={link.text} url={link.link} />
          </div>
        )}

        <StrapiMedia css={styles.image} {...image} />
      </div>
    </div>
  )
}

export const ContactInfo = ({
  items,
  addressName,
  columns,
}: SectionsContactInfoComponent) => (
  <section css={styles.section}>
    <div css={styles.contactItems}>
      {items &&
        items.length > 0 &&
        items.map((item) => <ContactItem key={item.id} {...item} />)}
    </div>

    <div css={styles.address}>
      <Typography css={styles.addressTitle}>{addressName}</Typography>
      <div css={styles.columns}>
        {columns?.map((column) => (
          <div key={column.id} css={styles.column}>
            <Paragraph text={column.text as RichTextBlock[]} />
          </div>
        ))}
      </div>
    </div>
  </section>
)
